import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

// レスポンス構造
export type GetOutputTargetResponce = {
  ConfirmDate: string,
  ConfirmUserId: string,
  ConfirmUserName: string
}[]

/**
 * 忘れず注文出力対象取得
 * 
 */
@Injectable()
export class GetOutputTargetService extends PlessJsonResponderSub<GetOutputTargetResponce> {
  successFunc: Function;

  /**
   * API呼び出し
   * @param successFunc 
   * @memberof GetOutputTargetService
   */
  execute(successFunc: Function = null){
    this.successFunc = successFunc;
    this.send('getOutputTarget', new PlessRequest());
  }

  /**
   * API成功後処理
   * @param data 
   * @memberof GetOutputTargetService
   */
  success(data: GetOutputTargetResponce): void {
    if ( this.successFunc !== null ) this.successFunc(data);
  }
}